import './styles/_index.scss';

import { ComponentsManager } from './components/ComponentsManager';

export default ComponentsManager;

export * from './components/lib/Config.model';
export * from './components/lib/DefinitionProperty.model';
export * from './components/lib/admin/ComponentInput';
